import axios from 'axios'

export default {
  getDuty (id) {
    return axios
      .get('/duty/' + id)
      .then(resp => {
        return resp.data
      })
  },
  addDuty (duty) {
    return axios
      .post('/duty', duty)
      .then(resp => {
        return resp.data
      })
  },
  updateDuty (duty) {
    return axios
      .put('/duty/' + duty.id, duty)
      .then(resp => {
        return resp.data
      })
  },
  delDuty (duty) {
    return axios
      .delete('/duty/' + duty.id, duty)
      .then(resp => {
        return resp.data
      })
  },
  sendMail (id) {
    return axios
      .put('/duty/email/' + id)
      .then(resp => {
        return resp
      })
  }
}



// WEBPACK FOOTER //
// ./src/service/dutyService.js